document.addEventListener("DOMContentLoaded", function() {
  var xhr = new XMLHttpRequest();
  // Usamos un endpoint rápido, seguro y que no es bloqueado
  xhr.open('GET', 'https://get.geojs.io/v1/ip/country.json');
  
  xhr.onreadystatechange = function() {
    if (xhr.readyState === 4 && xhr.status === 200) {
      try {
        var theData = JSON.parse(xhr.responseText);
        var theCountry = theData.country; 
        console.log("País detectado:", theCountry);    
        
        // ENCENDER MÉXICO
        if (theCountry === 'MX') {
          var elementosMx = document.querySelectorAll('.is_mx, .is_mx_btn');
          elementosMx.forEach(function(el) {
            el.style.display = 'inline-block';
          });
        } 
        // ENCENDER RESTO DEL MUNDO
        else {
          var elementosResto = document.querySelectorAll('.isnt_mx');
          elementosResto.forEach(function(el) {
            el.style.display = 'inline-block';
          });
        }
        
        // RELLENAR TEXTOS
        var textosPais = document.querySelectorAll('.the_country');
        textosPais.forEach(function(el) {
          el.innerHTML = theCountry;
        });

      } catch (e) {
        console.error("Error procesando geolocalización:", e);
      }
    }
  };
  
  xhr.send();
});